import React from 'react';
import ShareableCareCard from './ShareableCareCard';

const CARD_W = 1080;
const CARD_H = 1350;

/** Faithful, scaled-down live preview of the shareable card. */
export default function ShareCardPreview({ primary, secondary, giving, width = 200, testid = 'share-card-preview' }) {
  const scale = width / CARD_W;
  return (
    <div
      data-testid={testid}
      style={{
        width, height: Math.round(CARD_H * scale),
        overflow: 'hidden', borderRadius: 12,
        boxShadow: '0 8px 24px rgba(0,0,0,0.18)',
        flexShrink: 0,
      }}
    >
      <div style={{ transform: `scale(${scale})`, transformOrigin: 'top left' }}>
        <ShareableCareCard primary={primary} secondary={secondary} giving={giving} />
      </div>
    </div>
  );
}
